import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateSecuritySettingsRequest,
  UpdateField,
  FetchSecuritySettingsRequest,
} from './security-settings.actions'
import { getFormsState } from '../forms/forms.selectors'
import FormTrait from 'src/app/traits/form.trait'
import { getSecuritySettingsState } from './security-settings.selectors'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { select, Store } from '@ngrx/store'
import { Map } from 'immutable'

@Component({
  selector: 'app-security-settings',
  templateUrl: './security-settings.component.html',
  styleUrls: ['./security-settings.component.css'],
})
export class SecuritySettingsComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public forms: []
  private state$: Subscription
  private formsState$: Subscription
  public isLoading: boolean

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.state$ = this.store
      .pipe(select(getSecuritySettingsState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.formsState$ = this.store
      .pipe(select(getFormsState))
      .subscribe((state) => {
        this.forms = state.get('data').toJS()
      })

    this.store.dispatch(new FetchSecuritySettingsRequest())
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.formsState$.unsubscribe()
  }

  public checkboxChange(e: any, name?: string): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, e.target.checked, 'data'),
    )

    if (
      (name || e.target.name) === 'inactivityTimerEnabled' &&
      !e.target.checked
    ) {
      this.store.dispatch(
        new UpdateField('inactivityTimerDisplay', false, 'data'),
      )
    }
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'data'),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        '',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      SECURITY_TWO_FACTOR_AUTH_ENABLED: 'required',
      SECURITY_TWO_FACTOR_CODE_LENGTH: 'required',
      SECURITY_TWO_FACTOR_CODE_VALIDITY_MS: 'required',
      SECURITY_INACTIVITY_TIMER_ENABLED: 'required',
      SECURITY_INACTIVITY_TIMER_TIMEOUT_MS: 'required',
      SECURITY_INACTIVITY_TIMER_DISPLAY: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    validator.setAttributeNames({
      SECURITY_TWO_FACTOR_AUTH_ENABLED: 'two factor auth enabled',
      SECURITY_TWO_FACTOR_CODE_LENGTH: 'two factor code length',
      SECURITY_TWO_FACTOR_CODE_VALIDITY_MS: 'two factor code validity ms.',
      SECURITY_INACTIVITY_TIMER_ENABLED: 'inactivity timer enabled',
      SECURITY_INACTIVITY_TIMER_TIMEOUT_MS: 'inactivity timer timeout ms.',
      SECURITY_INACTIVITY_TIMER_DISPLAY: 'inactivity timer display',
    })

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const {
      SECURITY_TWO_FACTOR_CODE_LENGTH,
      SECURITY_TWO_FACTOR_CODE_VALIDITY_MS,
      SECURITY_INACTIVITY_TIMER_TIMEOUT_MS,
      ...payload
    } = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(
        new UpdateSecuritySettingsRequest({
          SECURITY_TWO_FACTOR_CODE_LENGTH: parseFloat(
            SECURITY_TWO_FACTOR_CODE_LENGTH,
          ),
          SECURITY_TWO_FACTOR_CODE_VALIDITY_MS: parseFloat(
            SECURITY_TWO_FACTOR_CODE_VALIDITY_MS,
          ),
          SECURITY_INACTIVITY_TIMER_TIMEOUT_MS: parseFloat(
            SECURITY_INACTIVITY_TIMER_TIMEOUT_MS,
          ),
          ...payload,
        }),
      )
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, ''),
      )
    }
  }
}
